import React from 'react';
import ReactDOM from 'react-dom';
import { Footer as FooterComponent } from '@codex-applications-brightworld/header';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import PropTypes from 'prop-types';
import urljoin from 'url-join';
import UISettings from '../../../utils/UISettings';

const Footer = ({ initialNavigation }) => (
  <EnvironmentThemeProvider>
    <FooterComponent
      initialNavigation={initialNavigation}
      useOnlyInitialData
    />
  </EnvironmentThemeProvider>
);

Footer.propTypes = {
  initialNavigation: PropTypes.shape({
    footer: PropTypes.shape({
      nav: PropTypes.shape({
        services: PropTypes.shape({
          title: PropTypes.string,
          nav: PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
            icon: PropTypes.string
          })
        }),
        links: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            nav: PropTypes.arrayOf(
              PropTypes.shape({
                label: PropTypes.string,
                link: PropTypes.string
              })
            )
          })
        ),
        cta: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            nav: PropTypes.arrayOf(
              PropTypes.shape({
                link: PropTypes.string,
                label: PropTypes.string,
                icon: PropTypes.string
              })
            )
          })
        ),
        policy: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string
          })
        ),
        social: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            link: PropTypes.string,
            title: PropTypes.string,
            icon: PropTypes.string
          })
        ),
        copyrights: PropTypes.string
      })
    })
  }).isRequired
};

const init = async () => {
  const storeApiUrl = UISettings.get('global.store_api_url');
  if (!storeApiUrl) {
    UISettings.watchChanges('global.store_api_url', 0, init);
    return;
  }
  
  const navigationApiUrl = urljoin(
    storeApiUrl.replace('/store/api', ''),
    '/ff/navigation/navigation',
    '?tenant=currys&includeFooter=1&brightworld=1'
  );
  let navigationApiResponse;
  try {
    navigationApiResponse = await fetch(navigationApiUrl);
  } catch (e) {
    console.error('Unable to load navigation data for footer.');
  }

  let navigationData;
  if (navigationApiResponse.ok) {
    try {
      navigationData = await navigationApiResponse.json();
    } catch (e) {
      console.error('Unable to parse navigation data for footer.');
    }
  }

  if (navigationData && navigationData.footer) {
    if (navigationData.footer.nav.services) {
      const pageFooterElement = document.querySelector('[data-component="page-footer"]');
      if (pageFooterElement) {
        ReactDOM.render(
          <Footer initialNavigation={navigationData} />,
          pageFooterElement
        );
      }
      const ssrFooterElement = document.querySelector('[data-component="ssr-footer"]');
      if (ssrFooterElement) {
        ssrFooterElement.style.display = 'none';
      }
      const ssrFooterCopyrightElement = document.querySelector('[data-component="ssr-footer-copyright"]');
      if (ssrFooterCopyrightElement) {
        ssrFooterCopyrightElement.style.display = 'none';
      }
    } else {
      console.error('Footer navigation data not compatible with brightworld.');
    }
  }

  
};

export default {
  init
};
